import * as React from "react";
import ActivityPlate from "../components/activities/Activity";
import ActivityHeader from "../components/activities/ActivityHeader";
import { Container, ScreenContainer } from "../components/wombat-ui";
import { H3 } from "../components/wombat-ui/components/Typography";
import useGetActivities from "../graphql/hooks/queries/useGetActivities";
import { Activity } from "../graphql/types/base";
import useTranslations from "../hooks/useTranslations";
import {
  getTimeAgoGroups,
  TimeAgoKeys,
  TimeAgoSortedData,
} from "../utils/timeAgo";

const ActivityListScreen = () => {
  const t = useTranslations();
  const { data, loading } = useGetActivities({ variables: { page: 1, per: 20, direction: "DESC", sortBy: "created_at"  }});
  const [sortedActivities, setSortedActivities] = React.useState<
    TimeAgoSortedData<Activity>
  >();

  const activities = data?.activities?.collection;

  React.useEffect(() => {
    if (activities) {
      setSortedActivities(getTimeAgoGroups<Activity>(activities));
    }
  }, [activities]);

  return (
    <ScreenContainer loading={loading}>
      <ActivityHeader />
      <Container>
        <div className="pb-8">
          <H3 description={t("activity.description")}>
            {t("activity.header")}
          </H3>
        </div>
        <div>
          {sortedActivities ? (
            TimeAgoKeys.map((timeAgo: string) => (
              <div id={timeAgo} key={timeAgo}>
                <div className="flex items-center px-3 py-1 space-x-3 text-xs font-semibold leading-6 uppercase rounded-md text-dark-100 w1-max bg-secondary-100">
                  {t(`activity.${timeAgo}`) as string}
                </div>
                <div className="py-6">
                  {sortedActivities[timeAgo].length === 0 ? (
                    <p className="pl-12 text-sm text-dark-100">
                      {t("activity.nothing")}
                    </p>
                  ) : (
                    sortedActivities[timeAgo].map((activity: Activity) => (
                      <ActivityPlate activity={activity} key={activity.id} />
                    ))
                  )}
                </div>
              </div>
            ))
          ) : (
            <p className="text-sm">{t("activity.nothing")}</p>
          )}
        </div>
      </Container>
    </ScreenContainer>
  );
};

export default ActivityListScreen;
